import { Marker, Position } from '@/map/domain/entities/map.types';

import { IMapRepository } from '@/map/domain/repositories/IMapRepository';

export class MapRepository implements IMapRepository {
  private markers: Marker[] = [];

  async getMarkers(): Promise<Marker[]> {
    return [...this.markers];
  }

  async addMarker(marker: Marker): Promise<void> {
    this.markers.push(marker);
  }

  async updateMarker(marker: Marker): Promise<void> {
    const index = this.markers.findIndex((m) => String(m.id) === String(marker.id));
    if (index === -1) {
      throw new Error(`Marker with id ${marker.id} not found`);
    }
    this.markers[index] = marker;
  }

  async removeMarker(markerId: string): Promise<void> {
    this.markers = this.markers.filter((m) => String(m.id) !== markerId);
  }

  async getMarkerPosition(markerId: string): Promise<Position> {
    const marker = this.markers.find((m) => String(m.id) === markerId);
    if (!marker) {
      throw new Error(`Marker with id ${markerId} not found`);
    }
    return marker.position;
  }

  async updateMarkerPosition(markerId: string, position: Position): Promise<void> {
    const marker = this.markers.find((m) => String(m.id) === markerId);
    if (!marker) {
      throw new Error(`Marker with id ${markerId} not found`);
    }
    marker.position = position;
  }
}
